import React from 'react';
import { Link, IndexLink } from 'react-router';
import PropTypes from 'prop-types';
// import TetherComponent from 'react-tether';

const menuList = [
  {
    path: '/',
    label: 'Home',
    index: true
  },
  {
    path: '/data',
    label: 'Data'
  },
  {
    path: '/country-profiles',
    label: 'Country Profiles'
  },
  {
    path: '/compare',
    label: 'Compare Countries'
  },
  {
    path: '/publications-data',
    label: 'Publications & ',
    labelBottom: 'Downloads',
    labelClass: 'no-wrap',
    isMultiLine: true
  },
  {
    path: '/media-center',
    label: 'Media Center'
  }

];

const mediaCenter = [
  {
    path: '/media-center/press-releases',
    label: 'Press releases'
  },
  {
    path: '/media-center/infographics',
    label: 'Infographics'
  },
  {
    path: '/media-center/videoclips',
    label: 'Video clips'
  },
  {
    path: '/media-center/media-coverages',
    label: 'Media Coverage'
  },
  {
    path: '/media-center/photo-galleries',
    label: 'Photo Gallery'
  },
  {
    path: '/media-center/contact',
    label: 'Contact'
  }
];


class MainNav extends React.Component {
  getSectionList(list) {
    return (
      <ul className="section-list">
        {list.map((item, j) => (
          <li key={j} className="list-item">
            <Link activeClassName="-current" to={item.path}>{item.label}</Link>
          </li>
        ))}
      </ul>
    );
  }
  render() {
    const { mobile, publicationsAndDataList } = this.props;
    return (
      <nav className="c-main-nav">
        <div className="list-container">
          <ul className="list">
            {menuList.map((item, i) => (
              <li key={i} className="list-item block-class" >
                {item.index ?
                  <IndexLink activeClassName="-current" to={item.path}>{item.label}</IndexLink> :
                  <Link activeClassName="-current" to={item.path}><span className={item.labelClass}>{item.label}</span> {item.labelBottom ? <span>{item.labelBottom}</span> : null}</Link>
                }
                {mobile && item.label === 'Publications & Downloads' && this.getSectionList(publicationsAndDataList)}
                {mobile && item.label === 'Media Center' && this.getSectionList(mediaCenter)}
              </li>
            ))}
          </ul>
        </div>
      </nav>
    );
  }
}

MainNav.propTypes = {
  mobile: PropTypes.bool,
  publicationsAndDataList: PropTypes.array
};

export default MainNav;



// WEBPACK FOOTER //
// ./app/components/common/MainNav.jsx